<template>
  <b-container>
    <b-row class="align-items-center">
      <b-col>
        <h2>Canned Notes</h2>
      </b-col>
      <b-col>
        <b-button class="float-right" variant="success" href="canned-note/new"
          >Add Canned Note</b-button
        >
      </b-col>
    </b-row>
    <b-table striped hover class="mt-3" :fields="fields" :items="items">
      <template #cell(edit)="data">
        <b-button
          class="mr-2"
          variant="primary"
          @click="$router.push(`/admin/canned-note/${data.item.id}/edit`)"
          >Edit</b-button
        >
      </template>

      <template #cell(name)="data">
        <div style="width: 200px">
          {{ data.item.name }}
        </div>
      </template>
      <template #cell(set_active)="data">
        {{ data.item.set_active === 1 ? "Active" : "Inactive" }}
      </template>
    </b-table>
  </b-container>
</template>

<script>
import NoteDataService from "@/services/NoteDataService";

export default {
  data() {
    return {
      items: [],
      fields: [
        { key: "edit", label: "Edit" },
        { key: "name", label: "Title" },
        { key: "details", label: "Message" },
        { key: "set_active", label: "Status" },
      ],
    };
  },
  created() {
    NoteDataService.getCanned()
      .then((res) => {
        this.items = res.data;
      })
      .catch((err) => {
        this.$emit("error", err);
      });
  },
};
</script>
